import PropTypes from 'prop-types'
import ReactCSSTransitionGroup from 'react-addons-css-transition-group'
import LoadingOverlay from './loading-overlay'

import css from './loader.scss'

const Loader = ({ children, loading }) => (
  <div className="position-rel">
    <ReactCSSTransitionGroup
      transitionName={css}
      transitionEnter={false}
      transitionLeaveTimeout={250}
    >
      {loading ? <LoadingOverlay /> : null}
    </ReactCSSTransitionGroup>
    {children}
  </div>
)

Loader.propTypes = {
  children: PropTypes.object,
  loading: PropTypes.bool,
}

export default Loader

//TODO: Make this a reuseable componenet in Baby-UI
